import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { buildNavigation } from '../../routes/nav'
import SidebarSection from './SidebarSection'
import SidebarContext from './SidebarContext'

const MOBILE_BREAKPOINT = 1280
const EXPAND_DELAY = 110
const COLLAPSE_DELAY = 160
const ACCOUNT_ITEM_KEY = 'conta-menu'

class Sidebar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      expanded: false,
      openSubmenuKey: null,
      isMobile: typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false
    }
    this.expandTimeout = null
    this.collapseTimeout = null
    this.handleResize = this.handleResize.bind(this)
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handleSubmenuOpen = this.handleSubmenuOpen.bind(this)
    this.handleSubmenuClose = this.handleSubmenuClose.bind(this)
    this.handleNavigate = this.handleNavigate.bind(this)
    this.handleBackdropClick = this.handleBackdropClick.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
    clearTimeout(this.expandTimeout)
    clearTimeout(this.collapseTimeout)
  }

  handleResize() {
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile, expanded: false, openSubmenuKey: null })
    }
  }

  handleMouseEnter() {
    if (this.state.isMobile) return
    clearTimeout(this.collapseTimeout)
    this.expandTimeout = setTimeout(() => {
      this.setState({ expanded: true })
    }, EXPAND_DELAY)
  }

  handleMouseLeave() {
    if (this.state.isMobile) return
    clearTimeout(this.expandTimeout)
    this.collapseTimeout = setTimeout(() => {
      this.setState({ expanded: false, openSubmenuKey: null })
    }, COLLAPSE_DELAY)
  }

  handleSubmenuOpen(key) {
    this.setState({ openSubmenuKey: key })
  }

  handleSubmenuClose() {
    if (this.state.openSubmenuKey === null) return
    this.setState({ openSubmenuKey: null })
  }

  handleNavigate() {
    const ctx = this.context
    if (this.state.isMobile && ctx && ctx.setMobileOpen) {
      ctx.setMobileOpen(false)
    }
    this.setState({ expanded: false, openSubmenuKey: null })
  }

  handleBackdropClick() {
    const ctx = this.context
    if (this.state.isMobile && ctx && ctx.setMobileOpen) {
      ctx.setMobileOpen(false)
      return
    }
    this.setState({ expanded: false, openSubmenuKey: null })
  }

  getNavFlags() {
    const { listBranch, defaultStore, authUser } = this.props
    const data = listBranch && listBranch.data
    const freshStoreName = defaultStore?.data?.FantasyName
    if (freshStoreName) this._cachedStoreName = freshStoreName
    const storeName = freshStoreName || this._cachedStoreName || ''
    const isReadonly = authUser?.readOnly || false
    // REV-1872: o item Promoção Ipiranga só aparece quando o back confirma
    // (POST /national-promotion/available, disparado pelo defaultHeader) que
    // algum posto participa; opt-in por filial funciona como trava extra
    const hasPromocaoIpiranga =
      this.props.ipirangaPromotionAvailable &&
      (!process.env.REACT_APP_OPTIN_PROMOCAO_IPIRANGA ||
        (Array.isArray(data) &&
          data.some(
            (b) => b.OptIns && b.OptIns.includes(process.env.REACT_APP_OPTIN_PROMOCAO_IPIRANGA)
          )))

    if (!Array.isArray(data) || data.length === 0) {
      return { hasDesconto: true, hasCashback: true, hasPromocaoIpiranga, isReadonly, storeName }
    }
    return {
      hasDesconto: data.some(
        (b) => b.OptIns && b.OptIns.includes(process.env.REACT_APP_OPTIN_DESCONTO)
      ),
      hasCashback: data.some(
        (b) => b.OptIns && b.OptIns.includes(process.env.REACT_APP_OPTIN_CASHBACK)
      ),
      hasPromocaoIpiranga,
      isReadonly,
      storeName
    }
  }

  // No desktop a seção Conta sai da lista e vira um item fixo no rodapé (nome
  // do posto) cujo flyout reúne os itens da conta; assim o menu cabe em telas
  // de notebook.
  buildAccountSection(contaSection) {
    if (!contaSection) return null
    const storeItem = contaSection.items.find((item) => item.isDisplay)
    return {
      key: contaSection.key,
      items: [
        {
          key: ACCOUNT_ITEM_KEY,
          name: storeItem ? storeItem.name : 'Minha conta',
          icon: '/assets/icons/nome_posto_logado.png',
          children: contaSection.items.filter((item) => !item.isDisplay)
        }
      ]
    }
  }

  render() {
    const { expanded, openSubmenuKey, isMobile } = this.state
    const ctx = this.context
    const mobileOpen = ctx ? ctx.mobileOpen : false
    const navigation = buildNavigation(this.getNavFlags())
    // Na gaveta mobile a lista rola e o submenu abre inline, então a Conta
    // continua como seção comum; o rodapé é só do desktop.
    const mainSections = isMobile
      ? navigation.sections
      : navigation.sections.filter((section) => section.key !== 'conta')
    const accountSection = isMobile
      ? null
      : this.buildAccountSection(navigation.sections.find((section) => section.key === 'conta'))

    const isExpanded = isMobile ? mobileOpen : expanded
    const showBackdrop = isMobile ? mobileOpen : expanded

    const className = [
      'app-sidebar',
      isExpanded ? 'is-expanded' : '',
      isMobile ? 'is-mobile' : '',
      isMobile && mobileOpen ? 'is-mobile-open' : ''
    ]
      .filter(Boolean)
      .join(' ')

    return (
      <>
        {showBackdrop && (
          <div
            className={`app-sidebar__backdrop ${
              isMobile ? 'app-sidebar__backdrop--mobile' : 'app-sidebar__backdrop--desktop'
            }`}
            onClick={this.handleBackdropClick}
          />
        )}
        <aside
          className={className}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <div className="app-sidebar__header">
            <img
              className="app-sidebar__logo"
              src="/assets/icons/sidebar-icons/portal-kmv-logo.svg"
              alt="Portal KMV"
            />
            <span className="app-sidebar__brand">PORTAL KMV</span>
          </div>
          <nav
            className="app-sidebar__nav"
            onScroll={isMobile ? undefined : this.handleSubmenuClose}
          >
            {mainSections.map((section) => (
              <SidebarSection
                key={section.key}
                section={section}
                expanded={isExpanded}
                openSubmenuKey={openSubmenuKey}
                onSubmenuOpen={this.handleSubmenuOpen}
                onSubmenuClose={this.handleSubmenuClose}
                onNavigate={this.handleNavigate}
              />
            ))}
          </nav>
          {accountSection && (
            <div className="app-sidebar__footer">
              <SidebarSection
                section={accountSection}
                expanded={isExpanded}
                openSubmenuKey={openSubmenuKey}
                onSubmenuOpen={this.handleSubmenuOpen}
                onSubmenuClose={this.handleSubmenuClose}
                onNavigate={this.handleNavigate}
              />
            </div>
          )}
        </aside>
      </>
    )
  }
}

Sidebar.contextType = SidebarContext

const mapStateToProps = ({ branchState, userState, ipirangaPromotionState }) => ({
  listBranch: branchState.listBranch,
  defaultStore: branchState.defaultStore,
  authUser: userState.authUser,
  ipirangaPromotionAvailable: ipirangaPromotionState.available
})

export default withRouter(connect(mapStateToProps)(Sidebar))
